import React, { useState } from "react";
import { useRoutes } from "react-router-dom";
import { Route, Routes } from "react-router-dom";

import { Provider } from "react-redux";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { store } from "./redux/store";

import "./i18n";
import routes from "./routes";

import { ThemeProvider } from "./contexts/ThemeContext";
import { SidebarProvider } from "./contexts/SidebarContext";
import { LayoutProvider } from "./contexts/LayoutContext";
import ChartJsDefaults from "./utils/ChartJsDefaults";

import { AuthProvider } from "./contexts/JWTContext";
// import { AuthProvider } from "./contexts/FirebaseAuthContext";
// import { AuthProvider } from "./contexts/Auth0Context";
// import { AuthProvider } from "./contexts/CognitoContext";
import Dashboard from "./layouts/Dashboard";
import VideoPlay from "./layouts/VideoPlay";
import SignInPage from "./pages/auth/SignIn";
import Auth from "./layouts/Auth";
// import { VideosContext, TestContext } from "./contexts/VideosContext";
import { VideoProvider } from "./contexts/VideosContext";

const App = () => {
  const content = useRoutes(routes);
  // const [videos, setVideos] = useState([{}]);
  // const valuesOfContext = { videos, setVideos };
  // console.log("videosAtApp", videos);

  return (
    <HelmetProvider>
      <Helmet titleTemplate="%s | DSP" defaultTitle="DSP" />
      <Provider store={store}>
        <ThemeProvider>
          <SidebarProvider>
            <LayoutProvider>
              <ChartJsDefaults />
              <AuthProvider>
                <VideoProvider>{content}</VideoProvider>
              </AuthProvider>
            </LayoutProvider>
          </SidebarProvider>
        </ThemeProvider>
      </Provider>
    </HelmetProvider>
  );
};

export default App;
